export default __webpack_public_path__ + "static/media/twitter_white.288b7aa2.svg";